export const dynamic = 'force-static';
export const revalidate = Infinity;

import Link from 'next/link';

export default function Footer() {
	return (
		<footer className="flex flex-col gap-2 sm:flex-row py-6 w-full shrink-0 items-center px-4 md:px-6 lg:px-12 border-t">
			<p className="text-xs text-muted-foreground">
				&copy; 2025 NOS Tech, Inc. All rights reserved.
			</p>
			<nav className="sm:ml-auto flex gap-4 sm:gap-6">
				<Link
					href="/terms"
					className="text-xs hover:underline underline-offset-4"
					prefetch={false}
				>
					Terms of Service
				</Link>
				<Link
					href="/privacy"
					className="text-xs hover:underline underline-offset-4"
					prefetch={false}
				>
					Privacy
				</Link>
			</nav>
		</footer>
	);
}
